function initCookieNotification() {
    var e = getCookie("cookie-policy-agreed"),
    i = $("#cookie-notification"),
    t = $(".agree", i);
    e || $("#cookie-notification").addClass("show"),
    t.on("click", function () {
        i.removeClass("show");
        var e = new Date;
        return e.setFullYear(e.getFullYear() + 1),
        console.log(e.getTime()),
        setCookie("cookie-policy-agreed", !0, e.getTime()),
        !1
    })
}
function setCookie(e, i, t) {
    var o = new Date;
    if (!t)
        t = o.setMonth(o.getMonth() + 1);
    o.setTime(t),
    document.cookie = e + "=" + i + (o ? ";expires=" + o.toUTCString() : "")
}
function getCookie(e) {
    var i = document.cookie.match("(^|;) ?" + e + "=([^;]*)(;|$)");
    return !!i && i[2]
}
function initSlideshow() {
    var e = 7e3;
    "undefined" != typeof SLIDESHOW_SPEED && (e = SLIDESHOW_SPEED),
    $(".slick-slider").slick({
        prevArrow: $(".prev"),
        nextArrow: $(".next"),
        dots: !0,
        appendDots: $(".slide-m-dots"),
        autoplay: !0,
        autoplaySpeed: e
    })
}
function initOrderForm() {
    var e = $("#subscription-form");
    e.length < 1 || (e.on("change", 'input[type="radio"], input[type="checkbox"]', function () {
            var e = $('[data-selector="' + $(this).attr("name") + '"]');
            if (!(e.length < 1)) {
                var i = $('[data-parent="' + $(this).val() + '"]');
                "radio" == $(this).attr("type") ? (e.hide(), e.find("input").prop("disabled", !0), i.show(), i.find("input").prop("disabled", !1)) : "checkbox" == $(this).attr("type") && ($(this).prop("checked") ? (e.find("input").prop("disabled", !0), e.hide()) : (e.show(), e.find("input").prop("disabled", !1)))
            }
        }), $('input[type="radio"]:checked', e).change())
}

$(document).ready(function () {
    initCookieNotification(), initOrderForm(), initSlideshow();
}),
    $(".toggler-block").click(function (e) {
        e.preventDefault(), $(this).parent(".logged-in-wrapper").toggleClass("active");
    }),
    $("#back-to-top").click(function (e) {
        e.preventDefault(), (document.body.scrollTop = 0), (document.documentElement.scrollTop = 0);
    }),
    $(".other-options").click(function (e) {
        e.preventDefault(), $(this).toggleClass("active"), $(this).parent(".other-options-wrapper").siblings(".other-options-menu").toggle();
    }),
    $(".second-menu-dropdown").click(function (e) {
        e.preventDefault(), $(this).siblings("ul").toggle(), $(".menu-img, .menu-img-up").toggle();
    }),
    $(".navbar-toggler").click(function (e) {
        e.preventDefault(), $(this).toggleClass("active");
    }),
    $(".lang-mobile-link").click(function (e) {
        e.preventDefault(), $(".main-menu-mobile").hide(), $(".choose-lang-menu").show(), $(".autorization-section").hide(), $(".langmenu-mobile-row").hide(), $(".subscription-section").hide();
    }),
    $("#search-link").click(function (e) {
        e.preventDefault(), $(".main-menu-mobile").hide(), $(".search-window").show();
    }),
    $(".back-to-menu").click(function (e) {
        e.preventDefault(),
            $(".choose-lang-menu, .choose-submenu, .search-window").hide(),
            $(".main-menu-mobile").show(),
            $(".navbar-nav-mobile .nav-item").removeClass("active"),
            $(".autorization-section").show(),
            $(".langmenu-mobile-row").show(),
            $(".subscription-section").show();
    }),
    $("#mobile-menu-links .nav-link").click(function (e) {
        e.preventDefault();
        var t = $(this);
        $(this).closest(".main-menu-mobile").hide(), $(this).closest(".main-menu-mobile").siblings(".choose-submenu").show();
        var i = $(".choose-submenu .nav-item");
        (activeSubcat = i.filter(function (e, i) {
            return $(i).data("menu") == t.data("menu");
        })),
            activeSubcat.addClass("active");
    }),
    $("#search-btn").click(function (e) {
        e.preventDefault(), $(this).closest(".bottom").hide(), $(".search-row").show(), $(".white-overlay").show(), $("#search").focus();
    }),
    $("#close-btn").click(function (e) {
        e.preventDefault(), $(this).closest(".search-row").hide(), $(".bottom").show(), $(".white-overlay").hide();
    }),
    $("#search-remove-btn").click(function (e) {
        e.preventDefault(), $("#search-mobile").val("");
    }),
    $(".subscribe-period").on("change", function () {
        var t = $(this).val(),
            e = $(this).siblings(".price-wrapper").children(".price-value");
        (activePrice = e.filter(function (e, i) {
            return $(i).data("price") == t;
        })),
            e.not(activePrice).removeClass("active"),
            activePrice.addClass("active");
    }),
    $(".subscribe-period").on("change", function () {
        var t = $(this).val(),
            e = $(this).closest(".mobile-radio-block").siblings(".price-wrapper").children(".price-value");
        (activePrice = e.filter(function (e, i) {
            return $(i).data("price") == t;
        })),
            e.not(activePrice).removeClass("active"),
            activePrice.addClass("active");
    }),
    $(".search-row .dropdown-menu").click(function (e) {
        e.stopPropagation();
    });
